export enum SeatingType {
  GeneralAdmission = 'generalAdmission',
  Seated = 'seated',
}
